import { Component } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { InventoryDetailsModule } from '../../../../germplasm-manager/inventory/details/inventory-details.module';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CoreUtilsModule } from '../../../../shared/core-utils';

@Component({
    selector: 'jhi-transaction-details-modal',
    standalone: true,
    imports: [
        NgSelectModule,
        TranslateModule,
        InventoryDetailsModule,
        CoreUtilsModule
    ],
    templateUrl: './transaction-details-modal.component.html',
    styleUrl: './transaction-details-modal.component.scss'
})
export class TransactionDetailsModalComponent {

    constructor(private activeModal: NgbActiveModal) { }

    gid: number;
    lotId: number;

    cancel() {
        this.activeModal.dismiss();
    }

    proceed() {
        this.activeModal.close();
    }

}
